document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".bsub-widget__plan-pricing").forEach(el => {
    const span = document.createElement("span")
    span.textContent = " / Delivery"
    el.appendChild(span)
  })
})
function initializeSwiper() {
  var swiper = new Swiper(".u-logo-slider", {
    slidesPerView: 4,
    spaceBetween: 30,
    autoplay: true,
    autoplay: {
    delay: 3000,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    breakpoints: {
      348: {
        slidesPerView: 3
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    }
  });
}
function initResultsslider() {
  var swiper = new Swiper(".uresulswiper", {
    loop:true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    spaceBetween: 20,
    autoplay: true,
    autoplay: {
    delay: 500000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        slidesPerView: 1.4,
         spaceBetween: 5,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 20,
      }
    }
  });
}
initslided();

$(document).on('shopify:section:load', function(event) {
  initslided();
});

$(document).on('shopify:section:unload', function(event) {
  initslided();
});

function initslided() {
  $('.u-trustpilot-slider').slick({
    infinite: false,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 30000,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 575,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
document.addEventListener('DOMContentLoaded', function() {
  const tabLinks = document.querySelectorAll('.tab-link');
  const tabPanes = document.querySelectorAll('.tab-pane');

  tabLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      const target = link.getAttribute('data-target');

      tabLinks.forEach(function(item) {
        item.classList.remove('active');
      });

      tabPanes.forEach(function(pane) {
        pane.classList.remove('active');
      });

      link.classList.add('active');
      document.getElementById(target).classList.add('active');
    });
  });
});
     document.addEventListener("DOMContentLoaded", function() {
      var coll = document.getElementsByClassName("collapsibleuz");
      var i;
      // Set the first collapsible element to be open by default
      if (coll.length > 0) {
        coll[0].classList.add("active");
        coll[0].nextElementSibling.style.maxHeight = coll[0].nextElementSibling.scrollHeight + "px";
      }

      for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function() {
          // Close all other tabs
          for (var j = 0; j < coll.length; j++) {
            if (coll[j] !== this) {
              coll[j].classList.remove("active");
              coll[j].nextElementSibling.style.maxHeight = null;
            }
          }
          // Toggle the current tab
          this.classList.toggle("active");
          var content = this.nextElementSibling;
          if (content.style.maxHeight) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        });
      }
    });
    var modal = document.getElementById("myModal");
var img = document.getElementById("myImg");

img.onclick = function(event){
  event.preventDefault();
  modal.classList.add("upopupimg");
}

var closes = document.querySelectorAll('.close');

closes.forEach(function(close) {
  close.addEventListener('click', function(event) {
    event.preventDefault();
    modal.classList.remove("upopupimg");
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Get all the gallery figures
  const galleryFigures = document.querySelectorAll('[data-gallery-figure]');

  // Function to toggle the display of .u-circle-with-text based on the index
  function toggleCircleTextDisplay() {
    galleryFigures.forEach(figure => {
      const index = figure.getAttribute('data-gallery-index');
      const circleText = figure.querySelector('.u-circle-with-text');

      if (index === '0') {
        // Show the circle text for index 0
        if (circleText) {
          circleText.style.display = 'block';
        }
      } else {
        // Hide the circle text for any index other than 0
        if (circleText) {
          circleText.style.display = 'none';
        }
      }
    });
  }

  // Call the function initially to set the correct display
  toggleCircleTextDisplay();

  // Optionally, you can add an event listener for when the gallery slides change
  // If you have a slider event to detect slide change, call toggleCircleTextDisplay again
});


function initAnnoucementSlider() {
  var swiper = new Swiper(".u-Swiper", {
         slidesPerView: 1.2,
        spaceBetween: 16,
        loop: false,
        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-pre",
        },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },    
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
  });
}


// document.addEventListener('DOMContentLoaded', function () {
//   contactcollapsible();
// });

// function contactcollapsible(){
//   var coll = document.querySelectorAll(".contactcontaineruz");

//   coll.forEach(function(item, index) {
//     var content = item.nextElementSibling;

//     // Open by default if data-open is true
//     if (item.dataset.open === "true") {
//       item.classList.add("active");
//       content.style.maxHeight = content.scrollHeight + "px";
//     }

//     // Click behavior
//     item.addEventListener("click", function() {
//       this.classList.toggle("active");

//       var content = this.nextElementSibling;
//       if (content) {
//         if (content.style.maxHeight){
//           content.style.maxHeight = null;
//         } else {
//           content.style.maxHeight = content.scrollHeight + "px";
//         }
//       }
//     });
//   });
// }

// var coll = document.getElementsByClassName("contactcontaineruz");

// for (var i = 0; i < coll.length; i++) {
//   var content = coll[i].nextElementSibling;

//   if (coll[i].classList.contains("active")) {
//     content.style.maxHeight = content.scrollHeight + "px";
//   }

//   coll[i].addEventListener("click", function () {
//     this.classList.toggle("active");
//     var content = this.nextElementSibling;

//     if (this.classList.contains("active")) {
//       content.style.maxHeight = content.scrollHeight + "px";
//     } else {
//       content.style.maxHeight = content.scrollHeight + "px"; 
//       requestAnimationFrame(() => {
//         content.style.maxHeight = "0px";
//       });
//     }
//   });
// }


